export enum HistoryQueryStringType {
  PANEL = 'panel',
  FULLSCREEN_POPUP = 'fullscreen_popup',
}

export const enum WorkStateQueryType {
  USERID = 'userId',
  START_DATE = 'startDate',
  END_DATE = 'endDate'
}
